import { IKanbanState } from './kanban-states.store'
import { GetterTree } from 'vuex';

const getters: GetterTree<IKanbanState, {}> = <GetterTree<IKanbanState, {}>>{
    kanbanUrl: (state: IKanbanState) => state.kanbanUrl,
}

export default getters;